// Traduções desta tela — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'auth.configuracoesPage.title': 'Configurações',
    'auth.configuracoesPage.eyebrow': 'Conta',
    'auth.configuracoesPage.subtitle': 'Seu acesso e a segurança da sua conta.',
    'auth.configuracoesPage.security': 'Segurança',
  },
  en: {
    'auth.configuracoesPage.title': 'Settings',
    'auth.configuracoesPage.eyebrow': 'Account',
    'auth.configuracoesPage.subtitle': 'Your access and account security.',
    'auth.configuracoesPage.security': 'Security',
  },
  es: {
    'auth.configuracoesPage.title': 'Configuración',
    'auth.configuracoesPage.eyebrow': 'Cuenta',
    'auth.configuracoesPage.subtitle': 'Su acceso y la seguridad de su cuenta.',
    'auth.configuracoesPage.security': 'Seguridad',
  },
}
